import React from "react";

import { styled } from "@material-ui/core/styles";
import { palette, compose, spacing, borders } from "@material-ui/system";
import PropTypes from "prop-types";

import useRbFlexViewItemStyles from "./useRbFlexViewItemStyles";

const Root = styled("div")(compose(palette, spacing, borders));
function RbFlexViewItem(props) {
  const { children, flex, ...other } = props;

  const classes = useRbFlexViewItemStyles(props);

  return (
    <Root {...other} className={classes.root}>
      {children}
    </Root>
  );
}

RbFlexViewItem.propTypes = {
  flex: PropTypes.string,
  children: PropTypes.node,
};

RbFlexViewItem.defaultProps = {
  flex: undefined,
  children: null,
};

export default React.memo(RbFlexViewItem);
